export enum Selectiontype {
    Monitor = 'monitor',
    IdItem = 'id'
}
